import api from './api';

export default class DeclaracoesService {
  constructor() {
    throw 'Não é possível instanciar DeclaracoesService';
  }

  static async lista() {
    const endpoint = mergeEndpoint();
    return await api.get(endpoint);
  }

  static async grava(declaracao) {
    const endpoint = mergeEndpoint();
    return await api.post(endpoint, declaracao);
  }

  static async atualiza(id, declaracao) {
    const endpoint = mergeEndpoint(id);
    return await api.put(endpoint, declaracao);
  }

  static async obtem(id) {
    const endpoint = mergeEndpoint(id);
    return await api.get(endpoint);
  }
}

const mergeEndpoint = id => {
  return `declaracoes-bens/${id || ''}`;
};



// WEBPACK FOOTER //
// ./src/services/declaracoesService.js